const OurTeam: React.FC = () => {
  return <>OurTeam page</>;
};

OurTeam.displayName = 'OurTeam';

export default OurTeam;
